import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { borderRadius, colors, spacing, typography } = themeVariables;

/* The logo's circle, from the design. The theme has no sizing scale. Exported
   because the circle itself is `ReviewCardPartnerLogo`, which is told what size to draw. */
export const LOGO_SIZE = '24px';

export const reply = css`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  gap: var(${spacing.xs});
  width: 100%;
  padding: var(${spacing.sm});
  border-radius: var(${borderRadius.md.mobile});
  background-color: var(${colors.surface.brand});
  color: var(${colors.content.default});
  text-decoration: none;
`;

export const content = css`
  display: flex;
  align-items: center;
  gap: var(${spacing.xs});
  /* So a long partner name truncates rather than pushing the chevron out of the row. */
  min-width: 0;
`;

export const label = css`
  overflow: hidden;
  font-family: var(${typography.body.fontFamily});
  font-size: var(${typography.body.sizes.md.fontSize});
  line-height: var(${typography.body.sizes.md.lineHeight});
  letter-spacing: var(${typography.body.letterSpacing});
  text-overflow: ellipsis;
  white-space: nowrap;
`;

/* 700 is a literal because the theme has one body weight and no bold step. */
export const partnerName = css`
  font-weight: 700;
`;

export const chevron = css`
  flex-shrink: 0;
  color: var(${colors.content.interactive});
`;
